import React, { useEffect } from "react";
import {
    Button,
  Card,
  Col,
  Flex,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Tooltip,
  Typography,
} from "antd";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { colors } from "../../../../../../constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { updateRefundAction } from "../../../../../../redux/services/configuration/configurationServices";
import { allowCharactersOnlyForDecimalNumbers } from "../../../../../../utils/appKeyStrokeLimitingUtils";
import { updateKeyValueAction } from "../../../../../../redux/services/common/commonServices";
import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import { UserOutlined } from "@ant-design/icons";
import styles from "./FineConfig.module.scss";
import Spinner from "../../../../../common/spinner/Spinner";

const FineConfig = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch dependencies */
  const dispatch = useDispatch();
  /* dispatch dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const type = Form.useWatch("type", { form, preserve: true });
  const initialValues = {
    type: null,
    fine_percentage: ""
  };
  const { systemSettings } = useSelector((state) => state.addonAndSponsorship);


  const handleGetTableData = () => {
    dispatch(getSystemSettingsAction(setLoading));
  }

  useEffect(()=>{
    handleGetTableData()
  },[])
  /* form dependencies */

  /* on Category changed */
  const onCategoryChanged = () => {
    resetDefaultFields()
  };
  /* on Category changed */

  /* reset default form fields */
  const resetDefaultFields = () => {
    form.setFieldsValue({
      fine_percentage: initialValues.fine_percentage
    });
  }
  /* reset default form fields */

  /* on submit */
  const onSubmit = (values) => {
    const dataToBeSent = {}
    switch (type) {
      case "customer":
        dataToBeSent.customer_account_fine_percentage = Number(values?.fine_percentage);
        break;
        
      case "service_provider":
        dataToBeSent.organization_account_fine_percentage = Number(values?.fine_percentage);
      break;
    
      default:
      break;
    }

    dispatch(updateKeyValueAction(dataToBeSent, setLoading)).then(()=>{
      handleGetTableData()
    })
    resetDefaultFields()
  };
  /* on submit */

  const fineConfigDetails = [
    // {
    //   title:t("Modules.Configuration.user"),
    //   fine_amount:systemSettings?.customer_account_fine_percentage,
    //   currency:systemSettings?.system_currency
    // },
    {
      title:t("Modules.Configuration.serviceProvider"),
      fine_amount:systemSettings?.organization_account_fine_percentage,
      currency:systemSettings?.system_currency
    }
  ]

  return (
    <div className={styles.configurationContainer}>
      {
        loading ? <Spinner/>
        :
      <Flex vertical gap="1rem">
      <Flex gap="1rem">
          <Typography.Title level={2}>{`${t("Modules.Configuration.fineAmount")}`}</Typography.Title>
        </Flex>
      <Flex gap="1rem">
        {
          fineConfigDetails?.map((element)=>{
            return (
            <Card
              bordered
              hoverable
              style={{ width: 300, padding: 0, borderRadius: 20, border:`1px solid ${colors.crimson}` }}
            >
              <Row gutter={[24, 24]} align="middle" justify="center">
                <Col span={8}>
                  <Button
                    type="primary"
                    shape="circle"
                    size="middle"
                    icon={<UserOutlined style={{ fontSize: 22 }} />}
                    style={{background:colors.crimson}}
                  />
                </Col>
                <Col span={16}>
                  <Flex vertical>
                    <Typography.Title level={3}>
                      {element.title}
                    </Typography.Title>
                    <Typography.Title
                      level={2}
                      style={{ margin: 0, color: colors.crimson }}
                    >
                      {`${element?.fine_amount} ${element?.currency}`}
                    </Typography.Title>
                  </Flex>
                </Col>
              </Row>
            </Card>
            )
          })
        }
      
      </Flex>
      <Flex vertical gap="2rem">
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          style={{ maxWidth: "400px" }}
          onFinish={onSubmit}
          initialValues={initialValues}
        >
          <Form.Item
            name="type"
            label={
              <RequiredLabel
                text={t("Modules.Configuration.userType")}
                required={true}
              />
            }
            rules={[
              {
                required: true,
                message: t("Modules.Configuration.pleaseSelectUserType"),
              },
            ]}
          >
            <Select
              loading={selectListLoader}
              options={[
                { value: "service_provider", label: "Service Provider" },
                // { value: "customer", label: "User" },
              ]}
              placeholder={t("Modules.Configuration.selectUserType")}
              onChange={onCategoryChanged}
            />
          </Form.Item>
            <>
              <Form.Item
                name="fine_percentage"
                label={
                  <Flex gap="1rem" align="center" justify="center">
                    <RequiredLabel text={t("Modules.Configuration.fine")} required={true}/>
                  </Flex>
                }
                rules={[
                  {
                    required: true,
                    message: t("Modules.Configuration.pleaseEnterFineAmount")
                  },
                  {
                    validator:(_,value)=>{
                        if(value && value < 1){
                          return Promise.reject(`${t("Modules.Configuration.fine")} ${t("CommonUtils.shouldBeGreaterThan0")}`)
                        }
                      return Promise.resolve();
                    }
                  }
                ]}>
                <Input
                  type="number"
                  placeholder={t("Modules.Configuration.enterFineAmount")}
                  onKeyDown={(e)=>allowCharactersOnlyForDecimalNumbers(e)}
                />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
                style={{ marginTop: "10px" }}
              >
                {t("CommonUtils.submit")}
              </Button>
            </>
          
        </Form>
      </Flex>
      </Flex>
      }
    </div>
  );
};

export default FineConfig;
